var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full mx-auto flex justify-center items-start",class:[
    _vm.isPageOpenedOnModal?
      'lg:w-page-container h-min max-h-100dvh pb-3 lg:p-6'
      :'pt-16 pb-3 lg:w-page-width lg:mb-6 lg:min-h-screenMinusHeader',
    {'pt-0 pb-0 h-min max-h-100dvh':_vm.isChatOpenOnMobile()}
  ]},[_c('div',{staticClass:"w-full flex flex-col items-center",class:{'lg:my-auto ':_vm.centerVertically}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }